/* State Imports */

import StateInterface from "../state-interface";

/* Section to edit Default State Data */

export const section_to_edit: StateInterface["section_to_edit"] = "";
